module.exports = __webpack_public_path__ + "static/media/product3.3e88140d.png";